<template>
  <div>
    <PageAllow controller="SubAccountAnalyses" action="mfSubAccount" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                type="datetime"
                v-model="options"
                show-radios
                :radios="datetimeRadios"
                selectRange="sameMonth"
                @changedModel="datetimeRageChanged = $event"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">
                  {{
                    $store.state.showSearchPanel
                      ? "fa-angle-up"
                      : "fa-angle-down"
                  }}
                </v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="print"
                dark
                class="me-2"
                @click.stop="exportRefund()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{
                  $t("ShopSubAccountSum.Export.refundExcel", [
                    $t("Nav.shopSubAccountSum", [$consts.shopName()]),
                  ])
                }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherSubAccount v-model="subAccountSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <SearcherStatus
                    v-model="options.sub_account_types"
                    :label="$t('ShopSubAccountSum.Fields.sub_account_type')"
                    :items="subAccountTypeItems"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.pay_types"
                    :label="$t('ShopSubAccountSum.payTypes.title')"
                    :items="$consts.shopSubAccount.pay_types"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="subAccounts"
            :options.sync="options"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="4">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money") }}
                    {{ receive_account_price_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money") }}
                    {{ sub_account_price_total | formatMoney }}</span
                  >
                </td>
                <td align="center">
                  <v-chip
                    small
                    label
                    :color="
                      receive_account_price_total == sub_account_price_total
                        ? 'primary'
                        : 'error'
                    "
                    text-color="white"
                    >{{
                      receive_account_price_total == sub_account_price_total
                        ? $t("SubAccountAnalyses.consistencyTRUE")
                        : $t("SubAccountAnalyses.consistencyFALSE")
                    }}
                  </v-chip>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ count_total | formatNoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ shop_count_total | formatNoDot }}</span>
                </td>
                <td></td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell"></div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("SubAccountAnalyses.TableHeaders.receiveMoney") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ receive_account_price_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("SubAccountAnalyses.TableHeaders.subAccountMoney") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ sub_account_price_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("SubAccountAnalyses.TableHeaders.consistency") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-chip
                      small
                      label
                      :color="
                        receive_account_price_total == sub_account_price_total
                          ? 'primary'
                          : 'error'
                      "
                      text-color="white"
                      >{{
                        receive_account_price_total == sub_account_price_total
                          ? $t("SubAccountAnalyses.consistencyTRUE")
                          : $t("SubAccountAnalyses.consistencyFALSE")
                      }}
                    </v-chip>
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("SubAccountAnalyses.TableHeaders.count") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ count_total | formatNoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("SubAccountAnalyses.TableHeaders.shopCount") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ shop_count_total | formatNoDot }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:item.sub_account_type="{ item }">
              {{ item.sub_account_type + "-" + item.sub_account_name }}
            </template>
            <template v-slot:item.third_account_number="{ item }">
              <span class="text-no-wrap subtitle-2">
                {{ item.account_number }}
              </span>
              <br />
              <span class="text-no-wrap subtitle-2">
                {{ item.account_name }}
              </span>
              <br />
              <span class="text-no-wrap caption secondary--text">
                {{ item.third_account_number }}
              </span>
            </template>
            <template v-slot:item.receive_account_price="{ item }">
              {{ $t("Global.money") }}
              {{ item.receive_account_price | formatMoney }}</template
            >
            <template v-slot:item.sub_account_price="{ item }">
              {{ $t("Global.money") }}
              {{ item.sub_account_price | formatMoney }}</template
            >
            <template v-slot:item.consistency="{ item }">
              <v-chip
                small
                label
                :color="
                  item.receive_account_price == item.sub_account_price
                    ? 'primary'
                    : 'error'
                "
                text-color="white"
              >
                {{
                  item.receive_account_price == item.sub_account_price
                    ? $t("SubAccountAnalyses.consistencyTRUE")
                    : $t("SubAccountAnalyses.consistencyFALSE")
                }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                outlined
                color="info"
                class="px-2 me-2"
                @click.stop="
                  $router.push({
                    path: '/shop-sub-account-sum/detail',
                  });
                  setLocalStorage(
                    item.third_account_number,
                    item.sub_account_type
                  );
                "
              >
                <v-icon x-small class="pe-1">fa-align-left</v-icon>
                {{ $t("Opt.details") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import consts from "@/consts";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherSubAccount from "@/components/plugins/SearcherSubAccount";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Authorizations from "@/api/authorizations";
import ShopSubAccount from "@/api/shop_sub_account";
import SubAccountSettings from "@/api/sub_account_settings";

// 取当月最后一天的日期
var current_year = new Date().getFullYear();
var next_month = new Date().getMonth() + 2;
if (next_month === 13) {
  current_year += 1;
  next_month = 1;
}
const startDateLong =
  new Date(current_year + "/" + next_month + "/" + 2).getTime() -
  24 * 60 * 60 * 1000;

//当前日期与当月第一天日期的天数差
const days = new Date().getDate() - 1;

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - days * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to:
    new Date(startDateLong).toISOString().substr(0, 10) + " 23:59:59",
  sub_account_time_from:
    new Date(new Date().getTime()).toISOString().substr(0, 10) + " 00:00:00",
  sub_account_time_to:
    new Date(new Date().getTime()).toISOString().substr(0, 10) + " 23:59:59",
  sub_account_types: [],
  sub_account_id: 0,
  pay_types: [1, 2, 3],
};

export default {
  components: {
    Breadcrumbs,
    PageAllow,
    SearcherDatetimeRangeWithRadio,
    SearcherSubAccount,
    SearcherStatus,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.shopSubAccountSum", [consts.shopName()]),
        disabled: true,
        href: "/shop-sub-account-sum",
      },
    ],

    datetimeRadios: () => [
      {
        key: "sub_account",
        text: i18n.t("ShopSubAccountSum.SubAccountTime"),
      },
      {
        key: "created",
        text: i18n.t("ShopSubAccountSum.OrderCreated"),
      },
    ],

    headers: () => [
      {
        text: i18n.t("ShopSubAccountSum.Fields.sub_account_type"),
        align: "start",
        sortable: false,
        value: "sub_account_type",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.pay_type"),
        align: "start",
        sortable: false,
        value: "payname",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.collection_bank"),
        align: "start",
        sortable: false,
        value: "bank_name",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.account_number"),
        align: "start",
        sortable: false,
        value: "third_account_number",
      },
      // {
      //   text: i18n.t("ShopSubAccountSum.Fields.third_account_num"),
      //   align: "start",
      //   sortable: false,
      //   value: "third_account_number",
      // },
      // {
      //   text: i18n.t("ShopSubAccountSum.Fields.account_name"),
      //   align: "start",
      //   sortable: false,
      //   value: "account_name",
      // },
      {
        text: i18n.t("ShopSubAccountSum.Fields.receive_price"),
        align: "end",
        sortable: false,
        value: "receive_account_price",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.sub_account_price"),
        align: "end",
        sortable: false,
        value: "sub_account_price",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.consistency"),
        align: "center",
        sortable: false,
        value: "consistency",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.count"),
        align: "end",
        sortable: false,
        value: "count",
      },
      {
        text: i18n.t("ShopSubAccountSum.Fields.shop_count", [
          consts.shopName(),
        ]),
        align: "end",
        sortable: false,
        value: "shop_count",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    subAccountTypeItems() {
      var types = [];
      if (this.subAccountTypes) {
        const keys = Object.keys(this.subAccountTypes);
        keys.map((key) => {
          const Description = key + "-" + this.subAccountTypes[key].name;
          types.push({
            value: key,
            text: Description,
            color: "primary",
            textColor: "white",
          });
        });

        //追加退款的搜索条件
        types.push({
          value: "TK",
          text: "TK-" + "退款",
          color: "danger",
          textColor: "white",
        });
      }
      return types;
    },

    ...mapState(["loading", "settings", "accessToken"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - days * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date(startDateLong).toISOString().substr(0, 10) + " 23:59:59",
    ],
    datetimeRageChanged: false,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    subAccountSelected: null,
    subAccounts: [],
    receive_account_price_total: 0,
    sub_account_price_total: 0,
    count_total: 0,
    shop_count_total: 0,
    paging: {},
    model: [],
    subAccountTypes: [],
  }),

  mounted() {
    if (!localStorage.getItem("midAccessToken")) {
      this.checkAccessToken();
    }
    //获取分账类型
    SubAccountSettings.fetchAll().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.subAccountTypes = response.data.sub_account_settings;
        }
      }.bind(this)
    );
    //取session中的搜索条件
    this.$commonUtils
      .loadOptions("shop-sub-account", ["subAccountSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "subAccountSelected":
                this.subAccountSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    checkAccessToken() {
      //校验当前登录的access_token
      Authorizations.checkAccessTokenToMid({
        yywd_access_token: this.accessToken,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            localStorage.setItem("midAccessToken", response.data.access_token);
            this.getSubAccountAnalyses();
          }
        }.bind(this)
      );
    },
    resetSearch() {
      this.subAccountSelected = null;
      this.datetimeRage = [
        new Date(new Date().getTime() - days * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date(startDateLong).toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      if (this.subAccountTypes) {
        this.options.sub_account_types = Object.keys(this.subAccountTypes);
      }
    },
    onSearch() {
      this.getSubAccountAnalyses();
    },
    getSubAccountAnalyses() {
      ShopSubAccount.fetch(Object.assign({}, this.options)).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.subAccounts = response.data.sub_accounts;
            this.receive_account_price_total =
              response.data.receive_account_price_total;
            this.sub_account_price_total =
              response.data.sub_account_price_total;
            this.count_total = response.data.count_total;
            this.shop_count_total = response.data.shop_count_total;
          } else if (response.data.error.code == "ERR667") {
            this.checkAccessToken();
          }
        }.bind(this)
      );
    },
    exportRefund() {
      ShopSubAccount.refundExports(Object.assign({}, this.options));
    },
    setLocalStorage(third_account_number, sub_account_type) {
      localStorage.setItem("third_account_number", third_account_number);
      localStorage.setItem("sub_account_type", sub_account_type);
      localStorage.setItem(
        "shopSubAccount_created_from",
        this.options.created_time_from
      );
      // localStorage.setItem(
      //   "shopSubAccount_created_from",
      //   this.options.created_time_from
      // );
      // localStorage.setItem(
      //   "shopSubAccount_created_to",
      //   this.options.created_time_to
      // );
      // localStorage.setItem(
      //   "shopSubAccount_sub_account_time_from",
      //   this.options.sub_account_time_from
      // );
      // localStorage.setItem(
      //   "shopSubAccount_sub_account_time_to",
      //   this.options.sub_account_time_to
      // );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getSubAccountAnalyses();
        sessionStorage.setItem(
          "shop-sub-account-options",
          JSON.stringify(this.options)
        );
      },
    },
    subAccountSelected: {
      handler() {
        this.options.sub_account_id = this.subAccountSelected
          ? this.subAccountSelected.id
          : 0;
        sessionStorage.setItem(
          "shop-sub-account-subAccountSelected",
          this.subAccountSelected
            ? JSON.stringify(this.subAccountSelected)
            : null
        );
      },
    },
    subAccountTypeItems: {
      deep: true,
      handler() {
        if (
          this.options.sub_account_types.length == 0 &&
          this.subAccountTypeItems
        ) {
          this.options.sub_account_types = this.subAccountTypeItems.map(
            (items) => {
              return items.value;
            }
          );
        }
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - days * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date(startDateLong).toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    datetimeRageChanged: {
      handler() {
        if (this.datetimeRageChanged) {
          this.$snackbar.error(
            i18n.t("ShopSubAccountSum.searcherDatePromtingMsg")
          );
          this.datetimeRageChanged = false;
        }
      },
    },
  },
};
</script>